import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的财务中心设置ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  payment_apply_type: [
    {...makeRule('请选择付款类型', 'integer')},
  ],
  first_subject_id: [
    {...makeRule('请选择一级科目', 'integer')},
  ]
}

export let companyFormRules = {
  name: [
    {...makeRule('请输入公司名称')},
  ],
  finance_ids: [
    {...makeRule('请选择财务负责人', 'array')},
  ],
  kingdee_number: [
    {...makeRule('请输入金蝶编码')},
  ]
}

export let companyAccountFormRules = {
  name: [
    {...makeRule('请输入账户名称')},
  ],
  our_company_id: [
    {...makeRule('请选择公司', 'integer')},
  ],
  number: [
    {...makeRule('请输入银行卡号')},
  ],
  bank_id: [
    {...makeRule('请选择开户银行', 'integer')},
  ]
}

export let finCenterConfigRules = {
  approve_amount_lv1: [
    {...makeRule('请输入一级审批起始值', 'integer', 'blur', true), min: 0},
  ],
  approve_amount_lv2: [
    {...makeRule('请输入二级审批起始值', 'integer', 'blur', true), min: 0},
  ],
  approve_amount_lv3: [
    {...makeRule('请输入三级审批起始值', 'integer', 'blur', true), min: 0},
  ],
  approve_amount_lv4: [
    {...makeRule('请输入四级审批起始值', 'integer', 'blur', true), min: 0},
  ],
}

export let departmentJobFormRules = {
  name: [
    {...makeRule('请输入部门岗位名称')}
  ]
}

export let invoiceNameAddRule = {
  tax_rate: [
    {...makeRule('请输入税率，范围 0-100', 'integer')},
  ],
  product_num: [
    {...makeRule('请输入商品编码', 'string')},
  ],
  name: [
    {...makeRule('请输入开票名称', 'string')},
  ],
  type_id: [
    {...makeRule('请选择开票名称类别', 'integer')},
  ],
}

export let invoiceNameEditRule = {
  tax_rate: [
    {...makeRule('请输入税率，范围 0-100', 'integer')},
  ],
  product_num: [
    {...makeRule('请输入商品编码', 'string')},
  ]
}

export let baiWangCfgForm = {
  tax_panel_pwd: [
    {...makeRule('税控盘口令 不能为空', 'string')},
  ],
  digital_cert_pwd: [
    {...makeRule('数字证书密码 不能为空', 'string')},
  ],
  bw_register_code: [
    {...makeRule('百旺注册码 不能为空', 'string')},
  ],
  address_and_phone: [
    {...makeRule('销货地址单位及电话 不能为空', 'string')},
  ],
  bank_acct: [
    {...makeRule('销货单位银行帐号 不能为空', 'string')},
  ],
  code_version_number: [
    {...makeRule('百旺编码版本号 不能为空', 'string')},
  ],
  ticket_payee: [
    {...makeRule('收款人 不能为空', 'string')},
  ],
  ticket_reviewer: [
    {...makeRule('复核人 不能为空', 'string')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/finance-config/finance-config.rules.js